import { render, staticRenderFns } from "./Sums.vue?vue&type=template&id=08be02c4&"
import script from "./Sums.vue?vue&type=script&lang=js&"
export * from "./Sums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports